import React from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
import api from '../../apiClient/v1';

class ModalInventarios extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            data: null,
        }

        this.show = () => {
            this.setState({ visible: true }, () => {
                if (!this.state.data || Object.keys(this.state.data).length === 0) {
                    api.inventario.obtenerDetalles()
                        .then((response) => {
                            this.setState({
                                data: response,
                            })
                        })
                        .catch(error => {
                            console.log(error)
                        })
                }
            });
        }

        this.hide = () => this.setState({ visible: false })
    }

    render() {
        let totalCantidad = 0;
        let totalUnidades = 0;
        let promedioDotMin = 0;
        let promedioDot = 0;
        let promedioDotMax = 0;
        let promedioCont = 0;
        let index = 0;
        return (
            <div>
                <button className={'btn btn-info btn-xs'} onClick={this.show} style={{ marginTop: '15px', marginBottom: '15px', alignSelf: 'center', marginLeft: '5px', marginRight: '5px' }}>Servicios IG</button>
                <Modal show={this.state.visible} onHide={this.hide} bsSize="lg" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <span>
                                    Servicios IG (hasta el{' '}
                                    {this.props.hoy.format('D [de] MMMM, YYYY')})
                                </span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.data && Object.keys(this.state.data).length > 0 ?
                            <table className="table">
                                <thead style={{ position: 'sticky', top: '0px', zIndex: '1', backgroundColor: '#bde7ff' }}>
                                    <tr>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Regiones</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Cantidad IG</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Unidades Contadas</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Dotación Mínima</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Dotación Promedio</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Dotación Máxima</th>
                                        <th style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>Promedio Conteo/Hora</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(this.state.data).map(([region, info]) => {
                                        totalCantidad += Number(info.total_inventarios);
                                        totalUnidades += Number(info.total_unidades);
                                        promedioDotMin += Number(info.dotacion_minima);
                                        promedioDot += Number(info.dotacion_promedio);
                                        promedioDotMax += Number(info.dotacion_maxima);
                                        promedioCont += Number(info.promedio_conteo_hora);
                                        const fondo = index % 2 == 0 ? "white" : "#f5f5f5";
                                        index++;
                                        return (
                                            <tr key={index} style={{ backgroundColor: fondo }}>
                                                <td style={{ alignContent: 'center', textAlign: 'left', fontSize: 'small' }}>{region}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Number(info.total_inventarios).toLocaleString('de-DE')}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Number(info.total_unidades).toLocaleString('de-DE')}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Number(info.dotacion_minima).toLocaleString('de-DE')}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Math.round(Number(info.dotacion_promedio)).toLocaleString('de-DE')}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Number(info.dotacion_maxima).toLocaleString('de-DE')}</td>
                                                <td style={{ alignContent: 'center', textAlign: 'center', fontSize: 'small' }}>{Math.round(Number(info.promedio_conteo_hora)).toLocaleString('de-DE')}</td>
                                            </tr>)
                                    })}
                                </tbody>
                                <tfoot style={{ position: 'sticky', bottom: '0px', zIndex: '1', backgroundColor: '#bde7ff' }}>
                                    <tr>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>TOTALES</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{totalCantidad.toLocaleString('de-DE')}</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{totalUnidades.toLocaleString('de-DE')}</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{Math.round((promedioDotMin / Object.keys(this.state.data).length)).toLocaleString('de-DE')}</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{Math.round((promedioDot / Object.keys(this.state.data).length)).toLocaleString('de-DE')}</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{Math.round((promedioDotMax / Object.keys(this.state.data).length)).toLocaleString('de-DE')}</td>
                                        <td style={{ alignContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>{Math.round((promedioCont / Object.keys(this.state.data).length)).toLocaleString('de-DE')}</td>
                                    </tr>
                                </tfoot>
                            </table> : null}
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default ModalInventarios


// WEBPACK FOOTER //
// ./frontEnd/home/components/ModalInventarios.jsx